import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { ProductTypeContext, ProductTypeDescriptionContext } from "components/flexComponents/TopCities/TopCities";
import { UitkText } from "uitk-react-text";

const ProductTypeText = () => {
  const productType = React.useContext(ProductTypeContext);
  const productTypeDescription = React.useContext(ProductTypeDescriptionContext);
  const { formatText } = useLocalization();

  const productTypeText = {
    hotels: formatText("topCities.hotels"),
    flights: formatText("topCities.flights"),
    cars: formatText("topCities.cars"),
    packages: formatText("topCities.vacations"),
    vacation_rentals: formatText("topCities.vacationRentals"),
  };

  return <UitkText size={300}>{productTypeDescription || productTypeText[productType]}</UitkText>;
};

export default ProductTypeText;
